export const PRIMARY_COLUMN_JOINER = "  —  ";
export const BREAKDOWN_SEPARATOR = "[@breakdown@]";
